import { downloadUrl } from '@data'

export const getCommentImagePaths = (comment) => {
	const documents = comment?.documents
	if (!documents) return []
	return (Array.isArray(documents) ? documents : [documents]).filter(Boolean)
}

/**
 * getById returns an array per comment key — the live comment is the last entry, so its documents
 * are the ones that belong with the comment being shown.
 */
export const getLatestCommentImagePaths = (list) =>
	Array.isArray(list) ? getCommentImagePaths(list.slice(-1)[0]) : getCommentImagePaths(list)

/** Paths mapped to downloadable URLs (what <img> / the PDF <Image> need). */
export const toDocumentUrls = (paths) => (paths ?? []).map((path) => downloadUrl + path)

/** Convenience: one comment object -> its image URLs. */
export const getCommentImageUrls = (comment) => toDocumentUrls(getCommentImagePaths(comment))
